document.addEventListener( 'DOMContentLoaded', ( event ) => {
    const vehiculeButtons = document.querySelectorAll( '.vehicule-item' )

    if ( vehiculeButtons ) {
        vehiculeButtons.forEach( button => {
            const textLength = button.querySelector( 'span' ).getBoundingClientRect().width
            button.style.setProperty( '--text-length', `${ textLength }px` )
        } )
    }
} )

